import type { FC, PropsWithChildren } from 'react';
import { useMemo, useState } from 'react';

import { PageContext } from './page-header-context';

export const PageHeaderProvider: FC<PropsWithChildren<{ className?: string }>> = ({ children }) => {
  const [header, setHeader] = useState({});
  const value = useMemo(() => ({ setHeader, header }), [header]);
  return <PageContext.Provider value={value}>{children}</PageContext.Provider>;
};
